// @flow
import React from 'react'
import classnames from 'classnames'
import Icon from './Icon'

type PropsT = {
  customId?: string,
  className?: string,
  stroke?: string,
  fill?: string,
  title?: string,
}

const IconCircleAdd = ({customId='ic-circle-add', className='', stroke='none', fill='currentColor', title=''}: PropsT) => {
  const renderIcon = () => {
    return (<path d="m101 73c-8.8424031 0-16 7.1575969-16 16s7.1575969 16 16 16c8.842403 0 16-7.1575969 16-16s-7.157597-16-16-16zm0 29.473599c-7.410237 0-13.4735991-6.063362-13.4735991-13.473599s6.0633621-13.4735991 13.4735991-13.4735991 13.473599 6.0633621 13.473599 13.4735991-6.063362 13.473599-13.473599 13.473599zm8.420797-14.7367994h-7.157597v-7.1575969c0-.7152747-.547925-1.2632005-1.2632-1.2632005s-1.2632004.5479258-1.2632004 1.2632005v7.1575969h-7.1575969c-.7152747 0-1.2632005.5479258-1.2632005 1.2632004s.5479258 1.2632004 1.2632005 1.2632004h7.1575969v7.1575969c0 .7152747.5479254 1.2632005 1.2632004 1.2632005s1.2632-.5479258 1.2632-1.2632005v-7.1575969h7.157597c.715275 0 1.263201-.5479258 1.263201-1.2632004s-.54635-1.2632004-1.263201-1.2632004z" fill="#3a3c3d" transform="translate(-85 -73)"/>)
  }

  return (
    <Icon id={customId}
      className={classnames('IconDelete', className)}
      stroke={stroke}
      fill={fill}
      title={title}
      viewBox="0 0 32 32"
      renderPath={renderIcon}
    />
  )
}

export default IconCircleAdd
